import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../../shared/models/http';
import { QueryDto } from '../../../shared/models/query.dto';
import { BeaconGroupDto } from '../model/beacon-group.dto';
import { cleanEmptyValues } from '../../../shared/utils/functions.util';

@Injectable({
  providedIn: 'root',
})
export class BeaconGroupService {
  private url = `${environment.api}/spook/beacon-group`;

  constructor(
    private _http: HttpClient
  ) {}

  getBeaconGroups(filters: QueryDto): Observable<ApiResponse<BeaconGroupDto[]>> {
    const cleanedFilters = cleanEmptyValues(filters);
    return this._http.get<ApiResponse<BeaconGroupDto[]>>(this.url, { params: cleanedFilters });
  }
}
